import React from 'react';

function Lightbox({ images, currentIndex, isZoomed, onClose, onPrevious, onNext, onToggleZoom }) {
  if (currentIndex === null || !images.length) return null;

  return (
    <div className="lightbox" onClick={onClose}>
      <button className="lightbox-close" onClick={onClose}>
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
      
      {currentIndex > 0 && (
        <button className="lightbox-nav prev" onClick={(e) => { e.stopPropagation(); onPrevious(); }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>
      )}
      
      {currentIndex < images.length - 1 && (
        <button className="lightbox-nav next" onClick={(e) => { e.stopPropagation(); onNext(); }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>
      )}
      
      <div className="lightbox-counter">
        {currentIndex + 1} / {images.length}
      </div>
      
      <div 
        className={`lightbox-image-container ${isZoomed ? 'zoomed' : ''}`}
        onClick={(e) => { e.stopPropagation(); onToggleZoom(); }}
      >
        <img src={images[currentIndex]} alt="Enlarged mockup" />
      </div>
    </div>
  );
}

export default Lightbox;
